/** Returns embed URL for YouTube/Vimeo, or null for direct video / data URLs */
export const getVideoEmbedUrl = (url) => {
  if (!url || typeof url !== 'string') return null;
  try {
    if (url.includes('youtube.com/watch') || url.includes('youtu.be/')) {
      const id = url.includes('youtu.be/')
        ? url.split('youtu.be/')[1]?.split('?')[0]
        : new URL(url).searchParams.get('v');
      return id ? `https://www.youtube.com/embed/${id}?enablejsapi=1` : null;
    }
    if (url.includes('vimeo.com/') && !url.includes('/video/')) {
      const id = url.split('vimeo.com/')[1]?.split('?')[0]?.split('/')[0];
      return id ? `https://player.vimeo.com/video/${id}` : null;
    }
    if (url.includes('player.vimeo.com/video/')) return url;
  } catch (_) {}
  return null;
};

export const isVideoLink = (url) =>
  url && (url.startsWith('http://') || url.startsWith('https://'));

export const isVideoUpload = (url) => url && url.startsWith('data:');
